import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

// 全局请求拦截器：所有 axios 请求都带上 spytoken；X-AUTH-TOKEN 只在 token 有值时才带，避免传空值导致后端鉴权失败
axios.interceptors.request.use((config) => {
  const token = sessionStorage.site_current_token || sessionStorage.getItem('site_current_token') || store.state.token || '';
  if (token) {
    config.headers.common['X-AUTH-TOKEN'] = token;
  }
  config.headers.common['spytoken'] = 'fs79XXfHlg3itgF0aFF5sm3Wb7cK';
  console.log('[request interceptor] X-AUTH-TOKEN:', token, 'spytoken:', config.headers.common['spytoken']);
  return config;
});

import 'normalize.css'
import '@/assets/css/reset.css'
import '@/assets/js/remnew.js'
import '@/assets/css/base.css' /*引入公共样式*/
import 'vant/lib/button/style/less';
import Vant from 'vant'
import VueSignaturePad from "vue-signature-pad";
//引入icon
import '@/assets/icon/iconfont.css'
import { Overlay, Dialog } from 'vant';

import {
  Lazyload
} from 'vant';

import global_ from './components/tool/global'
Vue.prototype.GLOBAL = global_

import {
  getURLParameter
} from './common/common.js'
import {
  goLogin,
  getUserInfo,
  getUser,
  getBindVehicleState,
  checkUserHasPhone
} from './common/loginwx.js'
// ----------driver START----------
import 'driver.js/dist/driver.css'; // 引入driver基础样式
import '@/assets/css/driver.css'; // 引入driver自定义样式
import { driver } from 'driver.js'; // 引入driver

// --- 新增配置 ---
// 让 Vue 忽略微信的开放标签，避免出现 'Unknown custom element' 警告
Vue.config.ignoredElements = [
  'wx-open-launch-weapp',
  'wx-open-subscribe', // 如果您还使用了订阅消息组件
  'wx-open-data',      // 如果您还使用了开放数据组件
  // 可以继续添加其他微信 Web Components
];
// ----------------

const driverObj = driver(); // 创建driver实例
// 基础配置
const config = {
  popoverClass: 'driverjs-theme',
  showProgress: false,
  allowClose: false,
  allowKeyboardControl: false,
  nextBtnText: '下一步',
  prevBtnText: '上一步',
  doneBtnText: '完成',
};
// 应用基础配置
driverObj.setConfig(config)
// 全局注册driver实例
Vue.prototype.$driverObj = driverObj;

// 全局关闭新手引导
store.commit('set_firstTime');
// ----------driver END----------
Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(Overlay);
Vue.use(VueSignaturePad);
import 'vant/lib/index.css'
import './plugins/element.js'

Vue.config.productionTip = false
document.title = '苏豪丽天智储预约排队';


// 添加一个全局变量来记录是否已经检查过手机号
let hasCheckedPhone = false;

// 判断用户是否需要引导（已禁用，不再自动开启）
// import api from '@/fetch/api'

// 用户引导判断规则（已禁用）
// async function runBoot() {
//   // 点击确认，跳转到绑定页面
//   const res = await api.isNewUserAPI(store.state.wx_info.openid)
//   const { data } = JSON.parse(res)
//   // 如果是新用户, 则开启引导
//   data.length === 0 && store.commit('set_firstTimeOpen')
// }


router.beforeEach((to, from, next) => {
  var wx_code = getURLParameter('code');

  //页面设置account_id后 重置当前访问的account_id
  var openid = store.state.wx_info.openid;
  // openid = "oM41P6omXSD09eVay_Taj3X7qYOw"
  // openid = "oM41P6m5MNCImEDLsd3MAfdn2LKY"
  // openid = 'oM41P6tGYXq4aghovY7IsAZedYwM';
  // openid = 'oM41P6pGZY8nnQIz3txiyhamlFZM';
  // openid = "ogUNR54uZWn0P32KD_karNZ_IUJA";
   // openid = "ogUNR59z_Y0f5mPWuBqh-4_RmtGo"; //王玉瑶
  //  openid = "oM41P6rVPQh8UrQFs4cupR7wclwk";
  // openid = 'oM41P6oFB5YZNHZSGDPvnOcmRfS0'; //hych
  // openid = 'ogUNR50FlBeOrXlRFEFs6HQgf_gg'; //test
  // openid = 'oM41P6rKhYlkwcu1Uy6bmXr1p4K0' //老普货-卸货
  // openid = 'oM41P6i65E8ChGKgWZVYhZFEFXGU' //新普货-提货-卸货
  // openid = 'oM41P6s_B0hnUBdtYkIwMhmO4g4s' //普货无计划
  // openid = 'oM41P6qp0XLsAyW0HU4GDtVWCbu0' //危货有计划
  // openid = 'oM41P6mBRx4Le65lc31EIn1WoLic' //黎
  // openid = 'oM41P6ka7NwGW8XlxEJwKa0oPVXU' //新普货
  // openid = 'oM41P6kQ2T8qAxKq-EgKQyunPlDI' //新危货
  // openid = 'oM41P6js1_CFTJiLaGSEkbKuDSCs'
  // openid = 'oM41P6rwoHIIheGpu0YNimW3POjM'


  // 如果目标路径是绑定手机号的页面，直接放行
  if (to.path === '/userinfo') {
    next();
    return;
  }

  if (openid) {
    store.commit('set_openid', openid);
    
    // 判断是否已经检查过手机号，如果已经检查过，直接放行
    if (hasCheckedPhone) {
      next();
      return;
    }

    // 先检查本地是否有手机号
    if (checkUserHasPhone()) {
      getBindVehicleState(openid);
      hasCheckedPhone = true; // 标记已经检查过手机号

      next();
    } else {
      // 本地没有手机号，从服务器获取用户信息
      getUser(openid)
        .then(userData => {
          getBindVehicleState(openid);
          
          // 无论结果如何，标记为已检查
          hasCheckedPhone = true;
          
          // 如果服务器也没有手机号，弹窗提示用户去绑定
          if (!userData.phone) {
            Dialog.confirm({
              title: '提示',
              message: '您还未绑定手机号，请先完善个人信息',
              confirmButtonText: '去绑定',
              cancelButtonText: '稍后再说'
            }).then(async () => {
              // await runBoot()
              next({ path: '/userinfo', query: { bootFlag: 'firstTime' } });
            }).catch(async () => {
              // await runBoot()
              // 点击取消，继续访问原页面
              next({
                path: to.path,
                query: {
                  bootFlag: 'later'
                }
              });
            });
          } else {
            next();
          }
        })
        .catch((error) => {
          console.log("失败了",error)
          // API请求失败，继续访问原页面
          hasCheckedPhone = true; // 即使失败也标记为已检查
          next();
        });
    }
  } else {
    if (wx_code) {
      getUserInfo(wx_code, function() {
        if (store.state.wx_info.openid) {
          next();
        } else {
          document.title = '正在登录...';
          store.commit('set_login_go', to.fullPath); //页面将要跳转的地址
          goLogin(to.fullPath);
        }
      });
    } else {
      //如果token、code都不存在,页面第一次进入的时候
      document.title = '正在登录...';
      store.commit('set_login_go', to.fullPath); //页面将要跳转的地址
      goLogin(to.fullPath); //通过account_id获取appid,然后跳转到auth_url，获取code，然后会再重新执行router.beforeEach
    }
  }
});

// 路由变化监听：每次跳转都打出来源路径，便于排查"为什么到了某个页面"
router.afterEach((to, from) => {
  console.log('[route]', from.fullPath, '→', to.fullPath);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
